// 重置数据
export function resetData() {
    return {
        type: 'RESET_DATA'
    };
}

/**
 * 修改当前选中的tab类型
 * @param tabType {String}
 * @returns {{payload: {tabType: *}, type: string}}
 */
export function changeTabType(tabType) {
    return {
        type: 'CHANGE_EXCHANGE_TAB_TYPE',
        payload: {
            tabType
        }
    };
}

/**
 * 改变修改地址弹窗的显示状态
 * @param addressModalVisible {Boolean} 是否显示
 * @returns {{payload: {addressModalVisible: *}, type: string}}
 */
export function changeAddressModalVisible(addressModalVisible) {
    return {
        type: 'CHANGE_ADDRESS_MODAL_VISIBLE',
        payload: {
            addressModalVisible
        }
    };
}

/**
 * 存储当前要兑换的item元素
 * @param processExchangeCurItem {Object} 当前兑换的元素
 * @returns {{payload: {processExchangeCurItem: *}, type: string}}
 */
export function saveProcessExchangeCurItem(processExchangeCurItem) {
  return {
    type: 'CHANGE_SAVE—_PROCESS_CUR_ITEM',
    payload: {
      processExchangeCurItem
    }
};
}

/**
 * 改变当前选中的机构id
 * @param organization {Number} 机构Id
 * @returns {{payload: {organization: *}, type: string}}
 */
export function changeOrganization(organization) {
    return {
        type: 'CHANGE_ORGANIZATION',
        payload: {
            organization
        }
    };
}

/**
 * 改变兑换规则弹窗的显示状态
 * @param ruleModalVisible {Boolean} 是否显示
 * @returns {{payload: {ruleModalVisible: *}, type: string}}
 */
export function changeRuleModalVisible(ruleModalVisible) {
    return {
        type: 'CHANGE_RULE_MODAL_VISIBLE',
        payload: {
            ruleModalVisible
        }
    };
}